import { useMemo } from 'react';
import { LootProps, SeasonProps } from '../../leagues';
import { useBilling } from '../useBilling';

interface LeaguePrizePoolResult {
  baseTokens: number;
  totalTokens: number;
  totalPrizePool: number;
}

export const useLeaguePrizePool = (
  maxLoot: LootProps['total'],
  season?: SeasonProps,
): LeaguePrizePoolResult => {
  const { calculate } = useBilling();

  return useMemo(() => {
    if (!season) {
      return {
        baseTokens: 0,
        totalTokens: 0,
        totalPrizePool: 0,
      };
    }

    const { value, baseTokens, bonus, referralTokens } = season;
    const { net } = calculate(value);

    const has2x1 = bonus?.includes('2x1');
    const hasReferralTokens = (referralTokens || 0) > 0;

    let totalTokens = baseTokens;

    if (has2x1) {
      totalTokens = baseTokens * 2;
    }

    if (hasReferralTokens) {
      totalTokens += referralTokens || 0;
    }

    const totalPrizePool = baseTokens * net * maxLoot;

    return {
      baseTokens,
      totalTokens,
      totalPrizePool,
    };
  }, [season, calculate, maxLoot]);
};
